import * as Sentry from "@sentry/react";

export const initSentry = () => {
  const replayIntegration = Sentry.replayIntegration({
    maskAllText: false,
    blockAllMedia: false,
  });

  if (process.env.REACT_APP_NODE_ENV === "production") {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [replayIntegration],
      replaysSessionSampleRate: parseFloat(
        process.env.REACT_APP_SENTRY_REPLY_SESSION_SAMPLE_RATE || "1.0"
      ),
      replaysOnErrorSampleRate: parseFloat(
        process.env.REACT_APP_SENTRY_REPLY_ON_ERROR_SAMPLE_RATE || "1.0"
      ),
    });
  }
};
